import React from 'react';
import Menu from '../menu';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import cn from 'classnames';

const Header = ({ fluid, consended }) => {
  const History = useHistory();
  const client = useSelector((state) => state?.Auth?.client);
  const tenant = useSelector((state) => state?.Auth?.tenant);

  return (
    <header className="navbar navbar-expand-md navbar-dark d-print-none ">
      <div className={fluid ? 'container-fluid' : 'container-xl'}>
        <Menu.Mobile />
        <h1
          className={cn(
            'navbar-brand d-none-navbar-horizontal cursor-pointer navbar-brand-autodark '
          )}
          onClick={() => History.push('/')}
        >
          <img
            src={tenant?.logo || client?.logo}
            alt=""
            className="img-fluid rounded"
            style={{ maxWidth: 150, maxHeight: 30 }}
            id="logo-operator"
          />
        </h1>
        <div className="navbar-nav flex-row order-md-last">
          <Menu.Master />
          <Menu.User />
        </div>
        {consended ? <Menu.Consended fluid={fluid} /> : null}
      </div>
    </header>
  );
};

export default Header;
